module.exports = __webpack_public_path__ + "img/制糖行业数字化转型场景图谱.fce46764.jpg";